var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStethoscope(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.967,
    y: 16.145,
    transform: "matrix(0.9999 -0.0164 0.0164 0.9999 -0.3892 0.3964)",
    width: 0,
    height: 15.574,
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 287.991,
    y: 16.164,
    width: 0,
    height: 15.574,
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M254.639,16.014C251.406,6.704,242.551,0,232.154,0c-13.125,0-23.801,10.677-23.801,23.801s10.676,23.801,23.801,23.801 c10.397,0,19.252-6.704,22.485-16.014h9.761v128.33c0,57.516-46.792,104.309-104.309,104.309 c-57.516,0-104.309-46.793-104.309-104.309V31.588h9.762c3.233,9.31,12.088,16.014,22.485,16.014 c13.123,0,23.8-10.677,23.8-23.801C111.83,10.677,101.153,0,88.03,0C77.632,0,68.778,6.704,65.544,16.014H40.209v143.904 c0,63.377,49.436,115.416,111.77,119.603v16.971h15.574v-16.93c62.641-3.866,112.421-56.047,112.421-119.644V16.014H254.639z  M232.154,32.028c-4.536,0-8.227-3.691-8.227-8.227s3.691-8.227,8.227-8.227s8.227,3.691,8.227,8.227 S236.69,32.028,232.154,32.028z M88.03,15.574c4.536,0,8.226,3.691,8.226,8.227s-3.69,8.227-8.226,8.227s-8.227-3.691-8.227-8.227 S83.494,15.574,88.03,15.574z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 151.98,
    y: 303.762,
    width: 15.574,
    height: 56.066,
    style: {
      fill: "#add8dc",
      stroke: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#add8dc"
    },
    d: "M448.339,56.048c-26.367,0-47.821,21.452-47.821,47.822c0,23.738,17.389,43.483,40.095,47.189v217.039 c0,17.781-14.438,32.247-32.186,32.247c-17.748,0-32.186-14.466-32.186-32.247v-48.042c0-26.369-21.425-47.821-47.76-47.821 c-26.334,0-47.76,21.452-47.76,47.821v120.103c0,31.026-25.383,56.268-56.585,56.268s-56.585-25.242-56.585-56.268v-72.027 h-15.574v72.027c0,39.614,32.371,71.842,72.159,71.842s72.159-32.228,72.159-71.842V320.055c0-17.781,14.438-32.247,32.186-32.247 c17.748,0,32.186,14.466,32.186,32.247v48.042c0,26.369,21.425,47.821,47.76,47.821c26.334,0,47.76-21.452,47.76-47.821V151.036 c22.646-3.756,39.973-23.471,39.973-47.166C496.159,77.5,474.707,56.048,448.339,56.048z M448.339,136.117 c-17.781,0-32.247-14.466-32.247-32.247c0-17.782,14.466-32.248,32.247-32.248s32.248,14.466,32.248,32.248 C480.586,121.651,466.12,136.117,448.339,136.117z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      stroke: "#add8dc"
    },
    d: "M448.339,80.069c-13.125,0-23.801,10.677-23.801,23.801c0,13.124,10.676,23.801,23.801,23.801 s23.801-10.677,23.801-23.801C472.139,90.746,461.463,80.069,448.339,80.069z M448.339,112.096c-4.536,0-8.227-3.691-8.227-8.227 c0-4.536,3.691-8.227,8.227-8.227s8.227,3.691,8.227,8.227C456.566,108.406,452.875,112.096,448.339,112.096z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscope);
export default __webpack_public_path__ + "static/media/stethoscope.81d61ad24406d50707d53cf66e289c7d.svg";
export { ForwardRef as ReactComponent };